import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ColorPickerModule } from 'ngx-color-picker';

import { JYoguiSharedModule } from '../../shared';

import {
    ClassTypeService,
    ClassTypePopupService,
    ClassTypeComponent,
    ClassTypeDetailComponent,
    ClassTypeDialogComponent,
    ClassTypePopupComponent,
    ClassTypeDeletePopupComponent,
    ClassTypeDeleteDialogComponent,
    classTypeRoute,
    classTypePopupRoute,
    ClassTypeResolvePagingParams,
    ClassTypeTypeaheadService,
} from './';

let ENTITY_STATES = [
    ...classTypeRoute,
    ...classTypePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
        ColorPickerModule
    ],
    declarations: [
        ClassTypeComponent,
        ClassTypeDetailComponent,
        ClassTypeDialogComponent,
        ClassTypeDeleteDialogComponent,
        ClassTypePopupComponent,
        ClassTypeDeletePopupComponent,
    ],
    entryComponents: [
        ClassTypeComponent,
        ClassTypeDialogComponent,
        ClassTypePopupComponent,
        ClassTypeDeleteDialogComponent,
        ClassTypeDeletePopupComponent,
    ],
    providers: [
        ClassTypeService,
        ClassTypePopupService,
        ClassTypeResolvePagingParams,
        ClassTypeTypeaheadService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiClassTypeModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.module.ts